import getters from './megaphone/getters'
import mutations from './megaphone/mutations'
import actions from './megaphone/actions'

const state = {
  messages: {},
  products: [],
  productToBoost: null,
  modal: {
    isOpened: false,
    type: null
  },
  boostActionError: {
    productId: null,
    hasError: false
  },
  enabled: null
}

export default {
  state,
  getters,
  mutations,
  actions
}
